export const diasensImgUrls = {
  logoWhite: require('../assets/images/logos/diasens-white-logo.webp'),
  successImage: require('../assets/images/diasens-sucess.webp'),
}
